import styled from 'styled-components';
import createStyles from '@mui/styles/createStyles';

const FLEX_CENTER_COLUMN = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

const FormContainer = styled.form`
  width: 100%;
  ${FLEX_CENTER_COLUMN};
`;

const Footer = styled.div`
  width: 85%;
  ${FLEX_CENTER_COLUMN};
`;

const TEXT_FIELD = {
  width: '85%',
  marginTop: 2,
  marginBottom: 1,
};

const styles = createStyles({
  btnGoogle: {
    textTransform: 'none',
    m: '20px',
    '&:hover': { backgroundColor: 'transparent' },
  },
  headlineText: {
    width: '85%',
    marginTop: 2,
    marginBottom: 0,
  },
  textField: {
    ...TEXT_FIELD,
  },
  textFieldTwoInputs: {
    ...TEXT_FIELD,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  largeTextField: {
    width: '75%',
  },
  smallTextField: {
    width: '20%',
  },
  stateField: {
    minWidth: '30% !important',
  },
  registerStepsFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
});

export default styles;

export { FormContainer, Footer };
